import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4c600e87"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "pricing-table-checkbox-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedCheckbox = _resolveComponent("FriedCheckbox");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FriedCheckbox, {
            id: _ctx.inputId,
            disabled: _ctx.disabled,
            "data-external": "pricing-table-checkbox-input-edit",
            "model-value": _ctx.inputValue === '1',
            "onUpdate:modelValue": _ctx.handleUpdateChecked
        }, null, 8, ["id", "disabled", "model-value", "onUpdate:modelValue"])
    ]));
}
